export default __webpack_public_path__ + "3c80e7e938ffe24d8968858a6a4699ce.svg";